export default __webpack_public_path__ + "static/media/Nunito-ExtraLight.80a14a84.woff2";